export default __webpack_public_path__ + "static/media/discountBanner.abc52148.svg";